import { PlusOutlined, TeamOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout'
import { useSuspenseQuery } from '@apollo/client'
import { FetchInvitationsDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath, useCanForFeatures } from '@salescore/client-common'
import {
  CreateInvitationForm,
  InvitationsTable,
  OrganizationSubscriptionStatusTable,
} from '@salescore/client-feature-setting'
// eslint-disable-next-line sonarjs/deprecation
import { useModal } from '@salescore/frontend-common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Alert, Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

const Page = () => {
  const navigate = useNavigate()
  // eslint-disable-next-line sonarjs/deprecation
  const createModal = useModal()
  const organizationId = getOrganizationIdFromPath()
  const { t } = useTranslation()
  // eslint-disable-next-line sonarjs/deprecation
  const subscriptionStatusModal = useModal()
  const {
    // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
    data: { users, invitations, subscriptionStatus, organization },
    refetch,
  } = useSuspenseQuery(FetchInvitationsDocument, {
    variables: { organizationId: getOrganizationIdFromPath() },
    fetchPolicy: 'cache-and-network',
  })
  const onAfterFinish = async () => {
    await refetch()
    createModal.hideModal()
  }
  const { canManageInvitation } = useCanForFeatures()

  if (!canManageInvitation) {
    return (
      <div>
        <Alert type="warning" message={t(`権限がありません`)} />
      </div>
    )
  }

  return (
    <PageHeader
      title={t(`招待中ユーザー一覧`)}
      extra={[
        <Button
          key="button-to-users"
          icon={<TeamOutlined />}
          type="default"
          onClick={() => {
            void navigate({ to: '/o/$organizationId/v2/settings/users', params: { organizationId } })
          }}
        >
          {t(`ユーザー一覧へ`)}
        </Button>,
        <Button
          key="button-invitation"
          icon={<PlusOutlined />}
          type="primary"
          onClick={() => {
            if (subscriptionStatus.some((x) => x.isInvitationCreatable)) {
              createModal.showModal()
            } else {
              subscriptionStatusModal.showModal()
            }
          }}
        >
          {t(`招待する`)}
        </Button>,
      ]}
    >
      <InvitationsTable
        afterDestroy={() => {
          void refetch()
        }}
        invitations={invitations}
      />
      <Modal
        key="createModal"
        open={createModal.isModalVisible}
        onCancel={createModal.hideModal}
        width={'70%'}
        cancelText={t(`閉じる`)}
        okButtonProps={{ style: { display: 'none' } }}
        style={{ top: '3%' }}
        destroyOnHidden
      >
        <CreateInvitationForm
          onAfterFinish={onAfterFinish}
          invitations={invitations}
          users={users}
          subscriptionStatus={subscriptionStatus}
        />
      </Modal>
      <Modal
        key="subscriptionStatusModal"
        open={subscriptionStatusModal.isModalVisible}
        onCancel={subscriptionStatusModal.hideModal}
        width={'60%'}
        cancelText={t(`閉じる`)}
        okButtonProps={{ style: { display: 'none' } }}
        // style={{ top: '3%' }}
      >
        <Alert
          showIcon
          type="warning"
          message={
            <div>
              {t(`登録中のユーザー数が契約中のライセンス数を上回っているため、ユーザーの招待ができません。`)}
              <br />
              {t(`ライセンス数の追加をご希望の場合は、お手数ですが営業担当者までお声がけください。`)}
            </div>
          }
        />
        <OrganizationSubscriptionStatusTable subscriptionStatus={subscriptionStatus} />
      </Modal>
    </PageHeader>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/invitations')({
  component: Page,
})
